import { render } from "./ContentTemplateSections.vue?vue&type=template&id=8447b1b2&scoped=true"
import script from "./ContentTemplateSections.vue?vue&type=script&lang=js"
export * from "./ContentTemplateSections.vue?vue&type=script&lang=js"

import "./ContentTemplateSections.vue?vue&type=style&index=0&id=8447b1b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8447b1b2"]])

export default __exports__